<template>
  <FullPageProgressCircular v-if="!errorMessage" />
  <div v-else-if="errorMessage">{{ errorMessage }}</div>
</template>

<script lang="ts">

import { useSecurity } from "../stores/security";
import FullPageProgressCircular from "../components/FullPageProgressCircular.vue";
import { setConnectThemeIntoVuetifyLightTheme } from "../utils/theme";
import { useI18n } from "vue-i18n";
import _ from "lodash";

let i18nSetDateTimeFormat;

async function buildSecurityContext() {
  let { corvinaHost, accessToken, organizationId, instanceId, locale } = this.$route?.query || {};

  if (corvinaHost && organizationId && accessToken) {
    try {
      let security = await useSecurity();

      this.$i18n.locale = locale?.replace('_', '-') || "en-US";

      await security.buildCorvinaConnect({ corvinaHost, instanceId });

      if (security.connect?.theme) {
        setConnectThemeIntoVuetifyLightTheme(security.connect?.theme, this.$vuetify.theme.themes.light.colors);
      }

      if (security.connect?.defaultStandardTime) {
        i18nSetDateTimeFormat('en-US', security.connect.defaultStandardTime)
        i18nSetDateTimeFormat('de-DE', security.connect.defaultStandardTime)
        i18nSetDateTimeFormat('es-ES', security.connect.defaultStandardTime)
        i18nSetDateTimeFormat('fr-FR', security.connect.defaultStandardTime)
        i18nSetDateTimeFormat('it-IT', security.connect.defaultStandardTime)
      }

      this.errorMessage = "";
      this.$router.replace({ path: "/alarm-manager" });
    } catch (error) {
      console.error(error);
      this.errorMessage = `${this.$t('unableLoadDomainData', {corvinaHost, organizationId})}`;
    }
  } else {
    this.errorMessage = this.$t('YouMustProvideThreeQuerystringParams');
  }
}


export default {
  name: "Home",
  setup() {
    const { setDateTimeFormat } = useI18n();
    i18nSetDateTimeFormat = setDateTimeFormat;
  },
  data() {
    return {
      errorMessage: "",
    };
  },
  async created() {
    this.buildSecurityContext = buildSecurityContext;
    await this.buildSecurityContext();
  },
  async mounted() {
    //await this.buildSecurityContext();
  },
  async updated() {
    await this.buildSecurityContext();
  },
  components: { FullPageProgressCircular }
};
</script>
